import { render, staticRenderFns } from "./nav-control.vue?vue&type=template&id=60133701&"
import script from "./nav-control.vue?vue&type=script&lang=js&"
export * from "./nav-control.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "nav-control.vue"
export default component.exports